import { render, staticRenderFns } from "./cloneCourse.vue?vue&type=template&id=60053279"
import script from "./cloneCourse.vue?vue&type=script&lang=js"
export * from "./cloneCourse.vue?vue&type=script&lang=js"
import style0 from "./cloneCourse.vue?vue&type=style&index=0&id=60053279&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports